import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';
import { FONT_FAMILIES } from '../../../styles/constants';

export const usePaperStyles = makeStyles(() => ({
	root: {
		paddingTop: '9px',
		paddingBottom: '6px',
		paddingRight: '6px',
		paddingLeft: '6px',
		maxWidth: 1233,
		boxShadow: props =>
			props.applicationOriented ? `inset 0px 0px 4px 0.4px ` + COLORS.PRIMARY : `inset 0px 0px 4px 0.4px #a0a0a0 `,
		fontFamily: FONT_FAMILIES,
		fontSize: '14px'
	}
}));
